export enum ISPValidator {
  Maxsize = 'maxsize',
  Duplicate = 'duplicate',
  PassMatch = 'passMatch',
  Required = 'required',
}
